import React from 'react'

function Button({name, action}) {
  return (
    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px', backgroundColor: 'rgb(59, 42, 90)', padding: '10px 30px', cursor: 'pointer', color: 'white'}} onClick={action}>
        {name}
    </div>
  )
}

export default Button